import { Button, Flex, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const NotFound: React.FC = () => {
  const { t } = useTranslation("layout");
  const navigate = useNavigate();
  return (
    <Flex h="100vh" w="100vw" bg="gray.0" direction="column" justify="center" align="center">
      <Text fz={150} fw={600} c="gray">
        404
      </Text>
      <Text fz={16} fw={500} c="gray" ta="center">
        {t("notFound.title")}
      </Text>
      <Button variant="gradient" gradient={{ from: "var(--mantine-color-white)", to: "var(--mantine-color-yellow-5)", deg: 15 }} mt="lg" onClick={() => navigate("/")}>
        {t("notFound.home")}
      </Button>
    </Flex>
  );
};

export { NotFound };
